import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Spin } from "antd";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "./Indret.module.css";
import {
  MISSATGE_SPIN_INDRETS,
  TITOL_INDRETS
} from "../../constantsFormularis";
import { LOCAL_STORAGE_USER } from "../../constantsObservacions";
import {
  obtenirIndretsLlistat,
  getDadesIndretSeleccionat,
  setTitolApartat
} from "../../actions";
import {
  getUsuari,
  getPeticioIndretsEnCurs,
  getIndretsLlistat
} from "../../reducers";
import { rutaLogin, rutaIntroduccioIndret } from "../../routes";
import IndretTaula from "./IndretTaula";
import ErrorBoundaryWrapper from "../commons/ErrorBoundaryWrapper";
import { calFerLogin, senseRols, tokenDecoded } from "../../utils/usuariRols";
import { NotificacioError } from "../Notification";
import { esLlistaBuida } from "../../utils/formularis";

class Indret extends Component {
  constructor(props) {
    super(props);
    this.renderitzarTaula = this.renderitzarTaula.bind(this);
  }

  componentDidMount() {
    this.props.setTitolApartat(TITOL_INDRETS);
    this.obtenirIndrets();
  }

  obtenirIndrets = () => {
    this.props
      .obtenirIndretsLlistat()
      .then(dades => {
        if (dades.error || (dades.payload && dades.payload.message)) {
          return NotificacioError(
            "Avís llistat d'indrets",
            dades.error && dades.error.message
              ? dades.error.message
              : dades.payload.message
          );
        }
        if (esLlistaBuida(dades.payload, null)) {
          //Segon param null ja que dades.payload no té propietats en cas d'indrets'
          return NotificacioError("Avís", "No s'han trobat indrets.");
        }
      })
      .catch(error => {
        return NotificacioError(
          error.titol ? error.titol : "Error",
          error.message ? error.message : error
        );
      });
  };

  renderitzarTaula() {
    const { indrets, getDadesIndretSeleccionat, history } = this.props;

    return (
      <IndretTaula
        indrets={indrets}
        history={history}
        getDadesIndretSeleccionat={getDadesIndretSeleccionat}
      />
    );
  }

  recuperarUsuari = usuari => {
    if (!calFerLogin(usuari)) {
      return this.tokenTrobat(usuari);
    } else {
      const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
      if (token) {
        return this.tokenTrobat(tokenDecoded(token.token));
      } else {
        return <Redirect to={rutaLogin} />;
      }
    }
  };

  tokenTrobat = usuari => {
    const { isPeticioEnCurs, indrets } = this.props;

    if (senseRols(usuari)) {
      return <Redirect to={rutaLogin} />;
    }

    const hihaDades = indrets && Array.isArray(indrets) && indrets.length > 0;

    return (
      <Spin spinning={isPeticioEnCurs} tip={MISSATGE_SPIN_INDRETS} delay={300}>
        <div className={styles.indretBotoInserir}>
          <Link to={rutaIntroduccioIndret}>
            <Button type="primary" icon="plus-circle-o">
              Indret
            </Button>
          </Link>
        </div>
        {hihaDades ? (
          <div className={styles.indret}>{this.renderitzarTaula()}</div>
        ) : null}
      </Spin>
    );
  };

  render() {
    return this.recuperarUsuari(this.props.usuari);
  }
}

Indret.propTypes = {
  indrets: PropTypes.array,
  obtenirIndretsLlistat: PropTypes.func,
  isPeticioEnCurs: PropTypes.bool,
  getDadesIndretSeleccionat: PropTypes.func,
  history: PropTypes.object,
  setTitolApartat: PropTypes.func.isRequired,
  usuari: PropTypes.object
};

const mapStateToProps = state => {
  return {
    isPeticioEnCurs: getPeticioIndretsEnCurs(state),
    indrets: getIndretsLlistat(state),
    usuari: getUsuari(state)
  };
};

const mapDispatchToProps = {
  obtenirIndretsLlistat,
  getDadesIndretSeleccionat,
  setTitolApartat
};

export default ErrorBoundaryWrapper(
  connect(mapStateToProps, mapDispatchToProps)(Indret)
);
